import { createMuiTheme } from "@material-ui/core";
import { COLORS } from "../../../utils/js/constants";

export const productsPageStyle = (theme) => {

    const drawerWidth = 240;

    return {
        root: {
            display: "flex",
        },
        toolbar: {
            paddingRight: 24, // keep right padding when drawer closed
        },
        toolbarIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "0 8px",
            ...theme.mixins.toolbar,
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(["width", "margin"], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        menuButtonHidden: {
            display: "none",
        },
        drawerPaper: {
            position: "relative",
            whiteSpace: "nowrap",
            width: drawerWidth,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerPaperClose: {
            overflowX: "hidden",
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            width: theme.spacing(7),
            [theme.breakpoints.up("sm")]: {
                width: theme.spacing(9),
            },
        },
        appBarSpacer: theme.mixins.toolbar,
        content: {
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
            backgroundColor: 'black',
        },
        container: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
        },
        containerProducts: {
            padding: theme.spacing(4),
            display: 'flex',
            overflow: 'auto',
            flexDirection: 'column',
            background: COLORS.grey,
        },
        paper: {
            padding: theme.spacing(2),
            display: "flex",
            overflow: "auto",
            flexDirection: "column",
        },
        fixedHeight: {
            height: 240,
        },
        title: {
            color: COLORS.lightYellow,
            display: 'flex',
            alignItems: 'center'
        },
        label: {
            color: 'white',
            fontWeight: 'bold'
        },
        filter: {
            margin: '10px'
        },
        filterButton: {
            marginLeft: '10px'
        },
        registerButton: {
            background: COLORS.green2,
            color: 'white',
            fontWeight: 'bold'
        },
        select: {
            height: 30,
            minWidth: 150,
            color: 'white',
            ['&:focus']: {
                borderColor: 'white',
                color: 'white',
            },
            ['& .MuiSelect-iconOutlined']: {
                color: 'white'
            }
        },
        selectItem: {
            color: 'white',
        }
    }
}

export const theme = createMuiTheme({
    overrides: {
        MuiMenu: {
            list: {
                backgroundColor: "rgb(0 0 0 / 80%);"
            },
        },
        MuiListItem: {
            button: {
                '&.Mui-selected' : {
                    backgroundColor: 'rgb(240 147 7 / 55%);'
                },
                '&.Mui-selected:hover' : {
                    backgroundColor: 'rgb(240 147 7 / 75%);'
                },
            }
        }
    }
});
